<template>
  <div class="registrationBox">
    <img class="bannerImg" width="100%" src="@/assets/img/awardsAct/banner.jpg" alt="" >
    <div class="premiseBox">
      <div class="msgBox">
        <p class="msg">快应用联盟于2018年3月20日成立以来，联盟成员达到12家，手机端覆盖设备数超10亿，月活达5亿+，联盟生态内容不断丰富，生态也逐步扩大，越来越多的优秀产品脱颖而出。</p>
        <p class="msg">为激励和表彰优秀企业及开发者，联盟启动快应用“风锐奖”的评选活动，风锐奖基于行业趋势和热点，分别设置了快应用和快游戏的丰富奖项，欢迎大家踊跃报名。</p>
      </div>   
      <ul class="iconBox">
        <li>
          <img class="icon" width="100%" src="@/assets/img/awardsAct/premiseIcon1.png" alt="" >
        </li>
        <li>
          <img class="icon" width="100%" src="@/assets/img/awardsAct/premiseIcon2.png" alt="" >
        </li>
        <li>
          <img class="icon" width="100%" src="@/assets/img/awardsAct/premiseIcon3.png" alt="" >
        </li>
        <li>
          <img class="icon" width="100%" src="@/assets/img/awardsAct/premiseIcon4.png" alt="" >
        </li>
        <li>
          <img class="icon" width="100%" src="@/assets/img/awardsAct/premiseIcon5.png" alt="" >
        </li>
      </ul>         
    </div>
    <div class="prizeBox">
      <div class="appPrizeBox">
        <img class="appPrizeTitleImg" width="100%" src="@/assets/img/awardsAct/appPrizeTitleImg.png" alt="" >
        <ul class="prizeList appPrizeList">
          <li class="item appItem" v-for="(item,index) in awardsActAppList" :key="index">
            <img class="appPrizeImg" :src="item.icon" alt="">
            <p class="msg">{{item.name}}</p>
            <a class="btn" v-if="awardsActInfo['status']==2" href="javascript:;" @click="alertBox">立即报名</a>
          </li>
        </ul>
      </div>
      <div class="gamePrizeBox">
        <img class="gamePrizeTitleImg" src="@/assets/img/awardsAct/gamePrizeTitleImg.png" alt="">
        <ul class="prizeList gamePrizeList">
          <li class="item gameItem" v-for="(item,index) in awardsActGameList" :key="index">
            <img class="gamePrizeImg" :src="item.icon" alt="">
            <p class="msg">{{item.name}}</p>
            <a class="btn" v-if="awardsActInfo['status']==2" href="javascript:;" @click="alertBox">立即报名</a>
          </li>
        </ul>
      </div>
    </div>
    
    <div class="detailsBox">
      <div class="dateBox">
        <img class="dateTitleImg" src="@/assets/img/awardsAct/dateTitleImg.png" alt="">
        <ul class="timelineBox">
          <li class="item">
            <div class="title">开发者报名</div>
            <div class="radius" :class="{active:awardsActInfo['status']>1}"></div>
            <div class="date">{{awardsActInfo['applyDate'] | dateMMDD}}</div>
            <div class="line"></div>
          </li>
          <li class="item">
            <div class="title">官方评选</div>
            <div class="radius" :class="{active:awardsActInfo['status']>2}"></div>
            <div class="date">{{awardsActInfo['juryDate'] | dateMMDD}}</div>
            <div class="line"></div>
          </li>
          <li class="item">
            <div class="title">奖项公布</div>
            <div class="radius" :class="{active:awardsActInfo['status']>3}"></div>
            <div class="date">{{awardsActInfo['awardDate'] | dateMMDD}}</div>
          </li>
        </ul>
      </div>
      <div class="declareBox">
        <img class="declareTitleImg1" src="@/assets/img/awardsAct/declareTitleImg1.png" alt="">
        <div class="declareProcessBox">
          <dl class="item">
            <dt class="dt">
              <img class="starIcon" src="@/assets/img/awardsAct/starIcon1.png" alt="">
              登录快应用官网报名
            </dt>
            <dd class="dd">
              <p class="msg">· https://www.aiservhub.com/ </p>       
            </dd>
          </dl>
          <dl class="item">
            <dt class="dt">
              <img class="starIcon" src="@/assets/img/awardsAct/starIcon1.png" alt="">
              快应用报名   
            </dt>
            <dd class="dd">
              <p class="msg">· 登录账号后选择相应的奖项，点击“立即报名”；</p>     
              <p class="msg">· 根据奖项要求选择快应用；</p>
              <p class="msg">· 根据报名要求填写报名信息后提交即可；</p>
            </dd>
          </dl>
          <dl class="item">
            <dt class="dt">
              <img class="starIcon" src="@/assets/img/awardsAct/starIcon1.png" alt="">
              快游戏报名 
            </dt>
            <dd class="dd">
              <p class="msg">· 登录账号后选择相应的奖项，点击“立即报名”；</p>
              <p class="msg">· 根据报名要求填写报名信息后提交即可；</p>
            </dd>
          </dl>
        </div>
                        
        <img class="declareTitleImg2" src="@/assets/img/awardsAct/declareTitleImg2.png" alt="">
        <div class="declareWarningBox">
          <dl class="item">
            <dt class="dt">
              <img class="starIcon" src="@/assets/img/awardsAct/starIcon2.png" alt="">
              请合理选择、填写参报内容，本次报赛无须提交纸质版说明材料；
            </dt>
          </dl>
          <dl class="item">
            <dt class="dt">
              <img class="starIcon" src="@/assets/img/awardsAct/starIcon2.png" alt="">
              同款快应用/快游戏申报的奖项最多不超过2类，最终获奖不超过一项；
            </dt>
          </dl>
          <dl class="item">
            <dt class="dt">
              <img class="starIcon" src="@/assets/img/awardsAct/starIcon2.png" alt="">
              同一公司获奖数量最多不超过2个；
            </dt>
          </dl>
          <dl class="item">
            <dt class="dt">
              <img class="starIcon" src="@/assets/img/awardsAct/starIcon2.png" alt="">
              活动解释权归快应用联盟所有；
            </dt>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    this.queryAwardsActDetail();
    this.queryAwardsActAllType(1);
    this.queryAwardsActAllType(2);
  },
  data() {
    return {
      newDate:new Date().getTime(),
      awardsActInfo:{},//风锐奖详情
      awardsActAppList:[],//快应用奖项list
      awardsActGameList:[],//快游戏奖项list
    };
  },
  methods: { 
    alertBox(){
      this.$dialog.alert({
        message: '请使用电脑访问此页面报名',
        confirmButtonText:'好的',
        confirmButtonColor:'#2537B5',
      }).then(() => {
        // on close
      });
    },   
    //获取风锐奖详情
    queryAwardsActDetail(){
      this.$apis.awardsActServer.queryAwardsActDetail({
        id:'1',
      }).then(res=>{
        if (res["code"] == 0) {
          this.awardsActInfo = res["data"];
        } else {
          this.$dialog.alert({
            message: res['msg'],
            confirmButtonColor:'#2537B5',
          });
        }
      })
    },
    // 获取奖项列表
    queryAwardsActAllType(type) {
      singleAwardsAct.queryAwardsActAllType({
        "id": '1', //风锐奖id
        "type": type,// 类型：1应用；2游戏
      }).then(res => {
        if (res["code"] == 0) {
          if(type==1) this.awardsActAppList=res['data'];
          if(type==2)  this.awardsActGameList=res['data'];
        } 
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.registrationBox{
  .premiseBox{
    padding: 10px 40px;
    height: 516px;
    background: url(~@/assets/img/awardsAct/premiseBoxBj.jpg) no-repeat center center ;
    background-size:684px 490px;
    .msgBox{
      padding-top:20px;
      padding-bottom:22px;
      .msg{
        margin: 12px 0;
        font-size: 27px;
        font-weight: 400;
        color: #171C2F;
        line-height: 42px;
        text-indent:58px;
        text-align: justify;
      }
    }
    .iconBox{
      display: flex;
      justify-content: space-around;
      .icon{
        width: 74px;
        height: 74px;
      }
    }
  }
  .prizeBox{
    height: 1900px;
    background: url(~@/assets/img/awardsAct/prizeBoxBj.jpg) no-repeat top center;
    background-size:100% 100%;
    padding-top: 111px;
    .appPrizeTitleImg{
      display: block;
      margin: auto;
      width: 355px;
      height: 118px;
    }
    .gamePrizeTitleImg{
      display: block;
      margin: auto;
      margin-top:30px ;
      width: 355px;
      height: 118px;
    }
    .prizeList{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      .item{    
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        background: #FFF;
        box-shadow: 10px 9px 9px 1px rgba(0, 0, 19, 0.17);
        border-radius: 10px;
        .appPrizeImg{
          width: 178px;
          height: 178px;
        }
        .msg{
          font-size: 22px;
          font-weight: bold;
        }
        .btn{
          width: 137px;
          height: 40px;
          background: #2537B5;
          border-radius: 20px;
          line-height: 42px;
          text-align: center;
          font-size: 18px;
          color: #FFFFFF;
        }
      }
      .item:hover{
        transform: scale(1.04, 1.04);
        bottom: 5px;
        box-shadow: 14px 10px 20px 0px rgba(0, 0, 0, 0.3);
      }
    }
    .appPrizeList{
      margin:auto;
      height: 700px;
      padding: 10px;
      .appItem{
        width: 230px;
        height: 327px;
        padding: 25px 25px 15px 25px;
        margin:10px 0 ;
      }
    }
    .gamePrizeList{
      margin: auto;
      width: 530px;
      .gameItem{
        width: 250px;
        height: 337px;
        padding: 35px 35px 15px 35px;
        margin:20px 0 ;
      }
    }
  }
  .detailsBox{
    .dateBox{
      padding-top: 45px;
      height: 290px;
      .dateTitleImg{
        display: block;
        margin: auto;
        width: 394px;
        height: 64px;
      }
      .timelineBox{
        display: flex;
        justify-content: space-between;
        width: 660px;
        margin: auto;
        margin-top:80px;
        .item{
          position: relative;
          .title{
            width: 114px;
            height: 32px;
            border-radius: 15px;
            line-height: 30px;
            color: #fff;
            background: #2537B5;
            text-align: center;
            font-size: 17px;
          }
          .radius{
            border-radius: 50%;
            border: 2px solid #2537B5;
            width: 20px;
            height: 20px;
            margin:6px auto  8px ;
          }
          .active{
            background: #2537B5;
          }
          .date{
            font-size: 17px;
            color: #2537B5;
            text-align: center;
          }
          .line{
            position: absolute;
            left: 65px;
            bottom: 34px;
            width:256px;
            height: 2px;
            background: #2537B5;
          }
        }
      }
    }
    .declareBox{
      height: 1923px;
      padding-top: 80px;
      background: url(~@/assets/img/awardsAct/declareBoxBj.jpg) top center no-repeat ;
      background-size:100% 100%;
      .declareTitleImg1{
        display: block;
        width: 382px;
        height: 102px;
        margin: auto;
      }
      .declareProcessBox{
        margin: auto;
        margin-top: 41px;
        width: 610px;
        color: #fff;
        .item{
          display: flex;
          flex-wrap: wrap;
          margin-bottom: 45px;
          .dt{
            width: 100%;
            font-size: 30px;
            margin-bottom: 5px;
            .starIcon{
              width: 18px;
              height: 18px;
            }
          }
          .dd{
            width: 100%;
            padding-left: 20px;
            font-size: 24px;
            line-height: 36px;
            .msg{
              line-height: 40px;
            }
          }
        }
      }
      .declareTitleImg2{
        display: block;
        width: 484px;
        height: 92px;
        margin: auto;
        margin-top: 200px;
      }
      .declareWarningBox{
        margin: auto;
        margin-top: 85px;
        width: 650px;
        color: #fff;
        .item{
          display: flex;
          flex-wrap: wrap;
          margin-bottom: 45px;
          .dt{
            display: flex;
            width: 100%;
            font-size: 30px;
            margin-bottom: 5px;
            line-height: 50px;
            .starIcon{
              margin-top: 12px;
              margin-right: 10px;
              width: 18px;
              height: 18px;
            }
          }
        }
      }
    }
  }
}
</style>
